<script setup lang="ts">
    import { FetchError } from 'ofetch'
    import router from '@/router'

    type LoginForm = {
        username: string
        password: string
    }

    const { handleSubmit } = useForm<LoginForm>()
    const authStore = useAuthStore()
    const alertStore = useAlertStore()

    const fields: {
        [Property in keyof LoginForm]: any
    } = {
        username: useField(
            'username',
            (value) => !!value || 'E-Mail-Adresse muss ausgefüllt werden.'
        ),
        password: useField('password', (value) => !!value || 'Passwort muss ausgefüllt werden.')
    }
    const showPassword = ref(false)

    const submit = handleSubmit(async (values) => {
        try {
            await authStore.login(values)
            router.push({ name: 'dashboard' })
        } catch (e: unknown) {
            console.error(e)
            if (e instanceof FetchError) {
                alertStore.error(e.data.message)
            } else {
                alertStore.error('Da ist wohl etwas schief gelaufen.')
            }
        }
    })
</script>

<template>
    <v-row no-gutters justify="center">
        <v-col cols="12" sm="8" md="6" lg="6" xl="4" class="mt-6">
            <h1 class="text-center mb-4">Anmelden</h1>

            <v-form @submit.prevent="submit">
                <v-text-field
                    class="mb-4"
                    v-model.trim="fields.username.value.value"
                    label="E-Mail-Adresse"
                    name="username"
                    :error-messages="fields.username.errorMessage.value"
                    autocomplete="username"
                />

                <!-- Passwort -->
                <v-text-field
                    class="mb-4"
                    v-model.trim="fields.password.value.value"
                    label="Passwort"
                    :type="showPassword ? 'text' : 'password'"
                    name="password"
                    :error-messages="fields.password.errorMessage.value"
                    :append-inner-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append-inner="showPassword = !showPassword"
                />

                <!-- Anmelden-Button -->
                <v-btn
                    type="submit"
                    color="#00527e"
                    class="mb-2"
                    block
                    :loading="authStore.isLoading"
                >
                    Anmelden
                </v-btn>

                <div class="text-center mb-2">
                    <v-btn
                        size="x-small"
                        color="#00527e"
                        variant="plain"
                        :to="{ name: 'passwordReset' }"
                    >
                        Passwort vergessen oder noch kein Passwort?
                    </v-btn>
                </div>

                <div class="text-center">
                    <span>Noch keinen Account?</span>
                    <v-btn
                        size="small"
                        color="#00527e"
                        variant="plain"
                        data-test="register"
                        :to="{ name: 'register' }"
                    >
                        Jetzt registrieren
                    </v-btn>
                </div>
            </v-form>
        </v-col>
    </v-row>
</template>

<style scoped>
    .required label::after {
        content: '*';
    }
</style>
